{
  "faq.who-and-when.q": {
    "text": "Siapa yang perlu menyertai, dan bila?",
    "sourceHash": "251bbd2c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.who-and-when.0": {
    "text": "Setiap perniagaan berdaftar GST mesti menghantar data invois kepada IRAS menggunakan penyelesaian InvoiceNow-Ready, secara berfasa sehingga 1 April 2031.",
    "sourceHash": "9767c883",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.who-and-when.1": {
    "text": "Jika anda sudah berdaftar GST, fasa anda bergantung pada jumlah bekalan tahunan anda dalam tempoh perakaunan yang ditetapkan yang berakhir pada tahun kalendar 2025.",
    "sourceHash": "2ee88fe9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.who-and-when.2": {
    "text": "Hanya Perniagaan Terkecuali (Excluded Business) yang tidak terlibat: entiti luar negara, dan perniagaan yang berdaftar GST sepenuhnya kerana rejim caj songsang.",
    "sourceHash": "cee74f72",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-is-it.q": {
    "text": "Apa itu InvoiceNow, dan apa maksud keperluan GST ini?",
    "sourceHash": "05be8990",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-is-it.0": {
    "text": "InvoiceNow ialah rangkaian e-invois kebangsaan Singapura, berdasarkan piawaian antarabangsa Peppol.",
    "sourceHash": "fc70514e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-is-it.1": {
    "text": "Di bawah GST InvoiceNow Requirement, perniagaan berdaftar GST mesti menggunakan penyelesaian InvoiceNow-Ready untuk menghantar data invois kepada IRAS.",
    "sourceHash": "eecafed8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-is-it.2": {
    "text": "Menghantar dan menerima invois PDF melalui e-mel bukan e-invois.",
    "sourceHash": "a3355442",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.q": {
    "text": "Adakah ia percuma? Adakah geran?",
    "sourceHash": "4a32a5cd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.0": {
    "text": "Senarai pakej InvoiceNow percuma (FOC) IMDA menyatakan bahawa keseluruhan pakej penyelesaian adalah percuma, tanpa sebarang syarat.",
    "sourceHash": "e0c56a40",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.1": {
    "text": "Pakej percuma untuk perniagaan berdaftar GST tersedia sehingga 31 Mac 2031.",
    "sourceHash": "ef4224e2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.2": {
    "text": "Tarikh mula dan tamat berbeza mengikut penyedia, jadi semak senarai untuk pakej yang anda pilih.",
    "sourceHash": "c6294c6d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.3": {
    "text": "Geran termasuk Transition Grant S$1,000 untuk perniagaan dengan jumlah bekalan tahunan sehingga S$4 juta, Transition Grant S$5,000 untuk perniagaan lebih besar yang menyambungkan ERP sendiri, dan Queen Bee Grant S$25,000.",
    "sourceHash": "f1558d4b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.is-it-free.4": {
    "text": "PKS juga boleh menggunakan Productivity Solutions Grant untuk menampung sehingga 50% kos langganan perisian yang layak.",
    "sourceHash": "d6dd2dfc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.q": {
    "text": "Bagaimana jika pelanggan saya tiada dalam InvoiceNow?",
    "sourceHash": "e540e56d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.0": {
    "text": "Anda masih perlu mematuhinya. Invois jualan yang dikeluarkan di luar rangkaian dihantar kepada IRAS sebagai invois yang diekstrak oleh penyelesaian (Type 2), yang diekstrak dan dihantar secara automatik dan berkala oleh penyelesaian InvoiceNow-Ready anda.",
    "sourceHash": "a6b5e467",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.1": {
    "text": "Anda masih mesti mengumpul nama, UEN dan alamat pelanggan, kerana ia adalah elemen data mandatori. Untuk pelanggan luar negara, gunakan nombor pendaftaran perniagaan luar negara mereka sebagai Customer UEN.",
    "sourceHash": "ec014db2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.2": {
    "text": "Untuk pelanggan individu yang tidak berdaftar GST, anda boleh mengisi \"NA\" dalam kedua-dua medan Customer Name dan Customer UEN.",
    "sourceHash": "9d4ff1ab",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.3": {
    "text": "Anda tidak perlu mengesahkan butiran pelanggan, tetapi simpan rekod yang menyokongnya.",
    "sourceHash": "5ef1d019",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.partners-not-on-invoicenow.4": {
    "text": "Penyedia Access Point tidak boleh menukar invois PDF atau kertas kepada format Peppol.",
    "sourceHash": "9a74f877",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.non-compliance.q": {
    "text": "Bolehkah saya dikecualikan atau memilih untuk tidak menyertai?",
    "sourceHash": "eec59ad2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.non-compliance.0": {
    "text": "Tiada pilihan untuk tidak menyertai: semua perniagaan berdaftar GST mesti mematuhinya kecuali Perniagaan Terkecuali (Excluded Business).",
    "sourceHash": "6dc42750",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.non-compliance.1": {
    "text": "IRAS menyatakan bahawa perniagaan yang hanya membekal kepada entiti berkaitan, perniagaan kecil atau berjumlah rendah, dan perniagaan yang hanya membuat bekalan berkadar sifar atau dikecualikan tidak boleh dikecualikan.",
    "sourceHash": "767e74af",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.non-compliance.2": {
    "text": "Jika perniagaan anda sebahagian daripada susunan komersial, seperti kumpulan francais, yang berkongsi sistem ERP yang memerlukan lebih masa, anda boleh menulis kepada IRAS untuk meminta tarikh pelaksanaan yang lebih lewat. IRAS menimbang setiap permohonan satu demi satu.",
    "sourceHash": "0b296961",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.q": {
    "text": "Apakah penaltinya, dan seberapa tegas IRAS?",
    "sourceHash": "3dbc8ace",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.0": {
    "text": "IRAS menyatakan ia akan menyesuaikan pendekatan penguatkuasaannya dalam fasa awal bagi kesilapan atau ralat sebenar dalam data invois yang bukan disebabkan kecuaian atau dibuat tanpa alasan munasabah.",
    "sourceHash": "42096166",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.1": {
    "text": "Menjelang 1 April 2031 semua perniagaan berdaftar GST yang selebihnya mesti mematuhinya, dan tindakan penguatkuasaan boleh diambil terhadap perniagaan yang tidak mematuhinya.",
    "sourceHash": "655f4a55",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.2": {
    "text": "Jika anda mendaftar secara sukarela mulai 1 November 2025 dan tidak mematuhinya, permohonan anda boleh ditolak atau pendaftaran anda dibatalkan.",
    "sourceHash": "f9f72473",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.penalties.3": {
    "text": "Anda patut menyemak bahawa data invois anda sepadan dengan penyata GST anda, tetapi perbezaan yang sah (seperti masa, bekalan yang tidak memerlukan invois, atau cukai input yang tidak dituntut sepenuhnya) tidak dikenakan penalti jika anda menyimpan rekod dan boleh mengemukakannya apabila diminta.",
    "sourceHash": "cb6f8153",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.q": {
    "text": "Saya menjual melalui POS atau mesin daftar tunai. Adakah saya perlukan invois Peppol?",
    "sourceHash": "2124fbf0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.0": {
    "text": "Tidak. Untuk jualan POS anda boleh terus memberi resit kepada pelanggan tanpa mengeluarkan invois Peppol.",
    "sourceHash": "1a55e4f4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.1": {
    "text": "Anda masih mesti menghantar data jualan kepada IRAS. Anda boleh merekodkan jualan POS secara agregat, dan data agregat dihantar sebagai invois yang diekstrak oleh penyelesaian.",
    "sourceHash": "059e5f23",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.2": {
    "text": "Agregat dibenarkan untuk bekalan POS, bekalan yang mengeluarkan invois cukai ringkas atau resit, dan pembelian wang runcit seperti tuntutan kakitangan dan pembelian kad korporat.",
    "sourceHash": "30250c9b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.pos-aggregated.3": {
    "text": "Tanya penyedia penyelesaian InvoiceNow-Ready anda bagaimana sistem POS anda boleh disepadukan.",
    "sourceHash": "4c379c26",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.deadline.q": {
    "text": "Bilakah tarikh akhir untuk menghantar data invois?",
    "sourceHash": "0ca198b7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.deadline.0": {
    "text": "Semua data invois mesti sampai kepada IRAS sebelum yang lebih awal antara tarikh anda memfailkan penyata GST yang berkaitan, atau tarikh akhir pemfailan penyata itu.",
    "sourceHash": "801941ca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.deadline.1": {
    "text": "Penyata GST yang berkaitan ialah penyata yang meliputi tempoh perakaunan di mana transaksi berlaku.",
    "sourceHash": "9c3a59aa",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.deadline.2": {
    "text": "Invois Peppol (Type 1A) biasanya sampai kepada IRAS dalam masa nyata atau hampir masa nyata. Penghantaran yang diekstrak oleh penyelesaian (Types 1B, 2 dan 3) boleh dijadualkan secara berkala melalui penyelesaian anda.",
    "sourceHash": "c28259ca",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.acknowledgement.q": {
    "text": "Bagaimana saya tahu penghantaran saya berjaya?",
    "sourceHash": "d60095a3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.acknowledgement.0": {
    "text": "Bagi setiap penghantaran yang berjaya, anda menerima ID pengakuan (acknowledgement ID) daripada IRAS melalui penyelesaian InvoiceNow-Ready anda. Ia mengesahkan IRAS telah menerima penghantaran itu.",
    "sourceHash": "a8751f73",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.acknowledgement.1": {
    "text": "Penyedia penyelesaian InvoiceNow-Ready sepatutnya membolehkan anda melihat tarikh dan masa setiap penghantaran, statusnya dan ID pengakuan IRAS. Cara ia dipaparkan berbeza antara penyedia.",
    "sourceHash": "27207ce6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.q": {
    "text": "Bagaimana pembetulan, penghantaran semula dan nota kredit berfungsi?",
    "sourceHash": "da88dfe8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.0": {
    "text": "Jika anda meminda rekod invois dalam penyelesaian anda, contohnya kod kategori GST, anda mesti menghantar semula data invois. IRAS menganggap penghantaran terakhir sebagai rekod terkini.",
    "sourceHash": "497f109f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.1": {
    "text": "Jika anda tidak dapat menentukan layanan cukai input yang muktamad semasa menghantar data pembelian, anda tidak dijangka membuat pelarasan retrospektif jika nilai invois tidak berubah. Simpan rekod untuk menyokong layanan anda.",
    "sourceHash": "daf5c6fc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.2": {
    "text": "Keperluan ini menyokong dua jenis dokumen, invois dan nota kredit. Data nota kredit mesti dihantar walaupun jumlah GST tidak diselaraskan, menggunakan kod kategori GST yang sama seperti invois asal.",
    "sourceHash": "368b8074",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.resubmissions.3": {
    "text": "Untuk perubahan yang tidak menjejaskan nilai wang, seperti alamat penghantaran, pembekal menghantar invois yang disemak dengan Document UUID yang sama; jika tidak, pembekal mengeluarkan nota kredit.",
    "sourceHash": "a734bebb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.group-registration.q": {
    "text": "Kami ialah kumpulan GST. Bagaimana ia terpakai?",
    "sourceHash": "4942fb86",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.group-registration.0": {
    "text": "Entiti dalam kumpulan GST masih memfailkan satu penyata GST yang disatukan. Data invois boleh dihantar oleh setiap entiti atau secara disatukan oleh wakil kumpulan.",
    "sourceHash": "bd0a81d0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.group-registration.1": {
    "text": "Pendaftar GST sukarela baharu yang ditambah ke dalam kumpulan GST sedia ada mengikut fasa kumpulan itu.",
    "sourceHash": "ef5c81ea",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.group-registration.2": {
    "text": "Jika entiti dalam kumpulan ialah Perniagaan Terkecuali (Excluded Business), seperti entiti luar negara, hanya entiti itu yang tidak perlu menghantar data invois.",
    "sourceHash": "beaab745",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.q": {
    "text": "Data apa yang diterima oleh IRAS?",
    "sourceHash": "4e75adb1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.0": {
    "text": "Data invois untuk bekalan dan pembelian berkadar standard dan berkadar sifar serta bekalan dikecualikan, daripada invois, resit, nota debit dan nota kredit.",
    "sourceHash": "8c9b975f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.1": {
    "text": "Bekalan tempat jualan, bekalan dengan invois cukai ringkas, dan pembelian wang runcit boleh diagregat sebelum dihantar.",
    "sourceHash": "920fcacd",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.2": {
    "text": "Data yang tiada mana-mana elemen data mandatori akan ditolak secara automatik.",
    "sourceHash": "e392af3d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.what-data.3": {
    "text": "Dokumen sokongan tidak dihantar, tetapi anda mesti menyimpannya dan memberikannya jika IRAS meminta.",
    "sourceHash": "afd78d28",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.purchases.q": {
    "text": "Adakah invois pembelian juga dikira?",
    "sourceHash": "4f12cfc1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.purchases.0": {
    "text": "Ya, untuk pembelian berkadar standard dan berkadar sifar, yang menyokong cukai input yang anda tuntut.",
    "sourceHash": "7672e819",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.purchases.1": {
    "text": "Pembelian yang anda pilih untuk tidak menuntut cukai input berada di luar keperluan ini, tetapi anda masih boleh menghantarnya dengan kod kategori \"OP\".",
    "sourceHash": "80e73039",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.customer-not-registered.q": {
    "text": "Pelanggan saya tidak berdaftar GST. Adakah saya masih perlu menghantar data?",
    "sourceHash": "4eab912b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.customer-not-registered.0": {
    "text": "Ya. Anda mesti menghantar data invois dalam skop tanpa mengira status GST pelanggan anda, dan sama ada mereka menuntut cukai input atau tidak.",
    "sourceHash": "09a40f29",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.customer-not-registered.1": {
    "text": "Untuk pelanggan individu yang tidak berdaftar GST, anda boleh mengisi \"NA\" dalam medan Customer Name dan Customer UEN.",
    "sourceHash": "0fc67bce",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.software-ready.q": {
    "text": "Adakah perisian semasa saya sudah bersedia? Bagaimana jika belum?",
    "sourceHash": "eacb23c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.software-ready.0": {
    "text": "Semak senarai penyedia penyelesaian InvoiceNow-Ready yang ditauliahkan IMDA. Jika perisian anda tiada dalam senarai, anda boleh bekerjasama dengan penyedia Access Point yang ditauliahkan IMDA untuk menyambungkannya, bertukar kepada pakej percuma, atau berpindah kepada penyelesaian InvoiceNow-Ready.",
    "sourceHash": "60964d32",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.software-ready.1": {
    "text": "Jika anda menggunakan sistem ERP, anda perlukan penyedia Access Point yang ditauliahkan IMDA, secara terus atau melalui penyepadu sistem anda.",
    "sourceHash": "e3b2bf8c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.access-point.q": {
    "text": "Apa itu Access Point, dan adakah saya memerlukannya?",
    "sourceHash": "ac631798",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.access-point.0": {
    "text": "Penyedia Access Point (titik akses) mengendalikan get laluan dalam rangkaian InvoiceNow dan menghala invois ke destinasi yang betul.",
    "sourceHash": "a247f1a9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.access-point.1": {
    "text": "Penyedia penyelesaian InvoiceNow-Ready menawarkan perisian yang sudah disambung melalui Access Point bertauliah.",
    "sourceHash": "b329ef94",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.access-point.2": {
    "text": "Untuk menyambungkan sistem atau API anda sendiri, anda melalui penyedia Access Point yang ditauliahkan IMDA.",
    "sourceHash": "404063b5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.safety-and-returns.q": {
    "text": "Adakah data saya selamat? Adakah saya masih memfailkan penyata GST?",
    "sourceHash": "0f62bc53",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.safety-and-returns.0": {
    "text": "Hanya penyedia Access Point yang ditauliahkan IMDA beroperasi dalam rangkaian; data disulitkan semasa penghantaran dan ditandatangani secara digital.",
    "sourceHash": "ebff2042",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.safety-and-returns.1": {
    "text": "IRAS terikat dengan undang-undang kerahsiaan bagi data invois yang diterimanya.",
    "sourceHash": "8e913252",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "faq.safety-and-returns.2": {
    "text": "Anda masih memfailkan penyata GST dan menyimpan rekod, termasuk dokumen sumber, sekurang-kurangnya 5 tahun.",
    "sourceHash": "fef52c95",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p1.who": {
    "text": "Syarikat yang baru diperbadankan yang memohon pendaftaran GST secara sukarela dalam tempoh 6 bulan selepas diperbadankan",
    "sourceHash": "c42e068e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p2.who": {
    "text": "Mana-mana perniagaan yang memohon pendaftaran GST sukarela pada atau selepas 1 April 2026",
    "sourceHash": "a972bbdc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p3.who": {
    "text": "Perniagaan yang memohon pendaftaran GST wajib pada atau selepas 1 April 2028, dan pendaftar sedia ada dengan jumlah bekalan tahunan ≤ S$200,000",
    "sourceHash": "320d3e46",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p4.who": {
    "text": "Pendaftar sedia ada dengan jumlah bekalan tahunan ≤ S$1,000,000",
    "sourceHash": "247ce82c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p5.who": {
    "text": "Pendaftar sedia ada dengan jumlah bekalan tahunan ≤ S$4,000,000",
    "sourceHash": "00be1d53",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "phase.p6.who": {
    "text": "Pendaftar sedia ada dengan jumlah bekalan tahunan > S$4,000,000",
    "sourceHash": "0cb8bb21",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "when.totalAnnualSupplies": {
    "text": "Jumlah bekalan tahunan bermaksud jumlah nilai bekalan berkadar standard, berkadar sifar dan dikecualikan (Kotak 4 penyata GST) yang dibuat dalam semua tempoh perakaunan yang ditetapkan yang berakhir pada tahun kalendar 2025.",
    "sourceHash": "8894df11",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "when.myTaxMail": {
    "text": "IRAS telah memberitahu perniagaan yang berdaftar GST sebelum 2026 tentang tarikh pelaksanaan wajib mereka mulai pertengahan 2026. Perniagaan tanpa penyata GST untuk tempoh yang berakhir pada 2025 akan dimaklumkan tarikh mereka kemudian.",
    "sourceHash": "64e720e6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.mar-jun-sep-dec": {
    "text": "Jika tempoh anda berakhir pada Mac, Jun, September dan Disember, jumlahkan bekalan dari Januari 2025 hingga Disember 2025.",
    "sourceHash": "fa00a218",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.jan-apr-jul-oct": {
    "text": "Jika tempoh anda berakhir pada Januari, April, Julai dan Oktober, jumlahkan bekalan dari November 2024 hingga Oktober 2025.",
    "sourceHash": "11796ab6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.feb-may-aug-nov": {
    "text": "Jika tempoh anda berakhir pada Februari, Mei, Ogos dan November, jumlahkan bekalan dari Disember 2024 hingga November 2025.",
    "sourceHash": "90c6363c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.window.monthly": {
    "text": "Jumlah bekalan tahunan meliputi semua tempoh perakaunan yang ditetapkan yang berakhir pada tahun kalendar 2025.",
    "sourceHash": "1f16e3b1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.sum": {
    "text": "Jumlah bekalan tahunan ialah bekalan berkadar standard, berkadar sifar dan dikecualikan yang dibuat dalam semua tempoh perakaunan yang ditetapkan yang berakhir pada tahun kalendar 2025.",
    "sourceHash": "c2fbae07",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.nil": {
    "text": "Penyata GST sifar masih dikira sebagai penyata yang difailkan, jadi jumlah bekalan tahunan ialah S$0 dan keperluan terpakai mulai 1 April 2028.",
    "sourceHash": "e238758b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.extrapolate": {
    "text": "Jika penyata anda yang berakhir pada 2025 hanya meliputi sebahagian tahun, anda boleh mengunjurkan bekalan kepada setara 365 hari untuk mencari fasa anda.",
    "sourceHash": "3ae04638",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.noReturns": {
    "text": "Jika anda tiada penyata GST untuk tempoh yang berakhir pada tahun kalendar 2025, IRAS akan memberitahu tarikh pelaksanaan anda secara berasingan.",
    "sourceHash": "75ae99d9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.noReturnsPage": {
    "text": "Perniagaan tanpa penyata GST untuk tempoh yang berakhir pada 2025 akan dimaklumkan tarikh pelaksanaan mereka kemudian.",
    "sourceHash": "565bd55d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.volFrom2026": {
    "text": "Perniagaan yang memohon pendaftaran GST sukarela pada atau selepas 1 April 2026 mesti mematuhinya, tanpa mengira tarikh diperbadankan atau struktur perniagaan.",
    "sourceHash": "d015650a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.volCompulsoryApprovedAsVoluntary": {
    "text": "Permohonan pendaftaran wajib yang diluluskan secara sukarela juga mesti mematuhinya.",
    "sourceHash": "5466caab",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.newInc": {
    "text": "Mulai 1 November 2025, syarikat yang baru diperbadankan yang memohon pendaftaran sukarela dalam tempoh 6 bulan selepas diperbadankan mesti mematuhinya. Tarikh permohonan yang dikira, bukan tarikh kelulusan.",
    "sourceHash": "e5c52505",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.redomiciled": {
    "text": "Syarikat yang dipindahkan pendaftarannya ke Singapura tidak dianggap baru diperbadankan, jadi ia tidak termasuk dalam fasa 1 November 2025.",
    "sourceHash": "41ab4b66",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.compulsory2028": {
    "text": "Perniagaan yang memohon pendaftaran GST wajib pada atau selepas 1 April 2028 mesti mematuhinya sejak pendaftaran.",
    "sourceHash": "95f33e05",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.group": {
    "text": "Pendaftar GST sukarela baharu yang ditambah ke dalam kumpulan GST sedia ada mengikut fasa kumpulan itu. Hanya Perniagaan Terkecuali dalam kumpulan (seperti entiti luar negara) yang tidak perlu menghantar data invois.",
    "sourceHash": "62a4276e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.excluded": {
    "text": "Perniagaan Terkecuali (Excluded Business: entiti luar negara, dan perniagaan yang berdaftar sepenuhnya kerana rejim caj songsang) tidak diwajibkan mematuhinya.",
    "sourceHash": "151effd7",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.notRegistered": {
    "text": "Keperluan ini terpakai kepada perniagaan berdaftar GST.",
    "sourceHash": "f9b5c7a5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.band_p3": {
    "text": "Perniagaan berdaftar GST sedia ada dengan jumlah bekalan tahunan ≤ S$200,000 mesti mematuhinya mulai 1 April 2028.",
    "sourceHash": "94fffdf9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.band_p4": {
    "text": "Perniagaan berdaftar GST sedia ada dengan jumlah bekalan tahunan ≤ S$1,000,000 mesti mematuhinya mulai 1 April 2029.",
    "sourceHash": "00a99cf3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.band_p5": {
    "text": "Perniagaan berdaftar GST sedia ada dengan jumlah bekalan tahunan ≤ S$4,000,000 mesti mematuhinya mulai 1 April 2030.",
    "sourceHash": "61ee6fb8",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "calc.reason.band_p6": {
    "text": "Perniagaan berdaftar GST sedia ada dengan jumlah bekalan tahunan > S$4,000,000 mesti mematuhinya mulai 1 April 2031.",
    "sourceHash": "75b75ad3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "foc.0": {
    "text": "Senarai pakej InvoiceNow percuma (FOC) IMDA menyatakan bahawa keseluruhan pakej penyelesaian adalah percuma, tanpa sebarang syarat.",
    "sourceHash": "e0c56a40",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "foc.1": {
    "text": "Pakej percuma untuk perniagaan berdaftar GST tersedia sehingga 31 Mac 2031.",
    "sourceHash": "ef4224e2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "foc.2": {
    "text": "Tarikh mula dan tamat berbeza mengikut penyedia, jadi semak senarai untuk pakej yang anda pilih.",
    "sourceHash": "c6294c6d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.foc.amount": {
    "text": "PERCUMA",
    "sourceHash": "97a522db",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.foc.who": {
    "text": "Perniagaan berdaftar GST",
    "sourceHash": "f0c80296",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.foc.period": {
    "text": "Tersedia sehingga 31 Mac 2031; tarikh berbeza mengikut penyedia",
    "sourceHash": "c211f3a4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.foc.hrefLabel": {
    "text": "Senarai pakej percuma",
    "sourceHash": "9ee3fb61",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.amount": {
    "text": "S$1,000",
    "sourceHash": "2d421df5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.who": {
    "text": "Jumlah bekalan tahunan ≤ S$4 juta (tempoh yang berakhir pada 2025)",
    "sourceHash": "ae19ad94",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.period": {
    "text": "1 Julai 2026 hingga 31 Mac 2030, atau sehingga habis dituntut",
    "sourceHash": "7c3ba131",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.hrefLabel": {
    "text": "Borang tuntutan",
    "sourceHash": "00a2767f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.term.0": {
    "text": "Geran tunai untuk melanggan penyedia penyelesaian InvoiceNow-Ready (IRSP) atau menyambung melalui Access Point yang ditauliahkan IMDA.",
    "sourceHash": "fb34e4f6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.term.1": {
    "text": "Langgan penyelesaian IRSP (membayar sekurang-kurangnya 12 bulan), atau sepadukan ERP anda dengan Access Point bertauliah, selepas 26 Februari 2026.",
    "sourceHash": "a0c5bbcc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.term.2": {
    "text": "Tidak layak jika anda menggunakan mana-mana penyelesaian IRSP dalam tempoh 3 bulan sebelum menyertai.",
    "sourceHash": "f5885c0d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t1k.term.3": {
    "text": "Anda mesti mengaktifkan GST InvoiceNow sebelum tarikh akhir mandat anda dan menghantar data kepada IRAS.",
    "sourceHash": "33ddaf12",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.amount": {
    "text": "S$5,000",
    "sourceHash": "14515e89",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.who": {
    "text": "Jumlah bekalan tahunan > S$4 juta (tempoh yang berakhir pada 2025), dengan ERP sendiri",
    "sourceHash": "57f19348",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.period": {
    "text": "1 Julai 2026 hingga 31 Mac 2028, atau sehingga habis dituntut",
    "sourceHash": "a0cd6aa0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.hrefLabel": {
    "text": "Pernyataan minat (Expression of interest)",
    "sourceHash": "a8fdb5ae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.term.0": {
    "text": "Geran tunai untuk menyambungkan ERP anda sendiri kepada GST InvoiceNow melalui Access Point yang ditauliahkan IMDA.",
    "sourceHash": "f972f0b2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.term.1": {
    "text": "Mulakan projek selepas 26 Februari 2026, siapkan dalam tempoh 12 bulan, dan aktifkan GST InvoiceNow serta hantar data invois kepada IRAS menjelang 31 Mac 2028.",
    "sourceHash": "c8e4eb5d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.t5k.term.2": {
    "text": "Anda boleh menghantar Expression of Interest (pernyataan minat) dahulu, kemudian menuntut setelah anda memenuhi semua kriteria.",
    "sourceHash": "06b50f7d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.amount": {
    "text": "S$25,000",
    "sourceHash": "527e6ba3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.who": {
    "text": "Perolehan tahunan > S$4 juta, dengan ERP khas sendiri",
    "sourceHash": "beb5790b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.period": {
    "text": "1 Julai 2026 hingga 31 Mac 2030, atau sehingga habis dituntut",
    "sourceHash": "7c3ba131",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.hrefLabel": {
    "text": "Pernyataan minat (Expression of interest)",
    "sourceHash": "a8fdb5ae",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.term.0": {
    "text": "Untuk menyambungkan ERP khas anda sendiri kepada InvoiceNow dan berurus niaga dengan rakan niaga anda melaluinya.",
    "sourceHash": "866c9f97",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.term.1": {
    "text": "Memerlukan sekurang-kurangnya 200 pembekal atau 200 pelanggan perniagaan, dan menerima daripada sekurang-kurangnya 20 pembekal atau menghantar kepada sekurang-kurangnya 40 pelanggan melalui InvoiceNow menjelang 31 Mac 2031.",
    "sourceHash": "6e7cf731",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grant.queenBee.term.2": {
    "text": "Boleh digabungkan dengan Transition Grant S$5,000.",
    "sourceHash": "2f0cb8f3",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "grants.psg": {
    "text": "PKS juga boleh menggunakan Productivity Solutions Grant untuk menampung sehingga 50% kos langganan perisian yang layak.",
    "sourceHash": "d6dd2dfc",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "software.irspCount": {
    "text": "Senarai Penyedia Penyelesaian InvoiceNow-Ready IMDA, dikemas kini 12 Okt 2026, menamakan 81 penyedia, serta penjual semula.",
    "sourceHash": "7a5927d7",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "vendor.inHouseConnect": {
    "text": "Untuk penyelesaian perusahaan dalaman, peruntukkan 3 hingga 12 bulan untuk sambungan sistem kepada IRAS.",
    "sourceHash": "df11b6c4",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.0.lead": {
    "text": "LEBIH LANCAR",
    "sourceHash": "1c9ecb39",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.0.text": {
    "text": "Invois bergerak antara sistem kewangan sebagai data berstruktur, tanpa penghantaran, penerimaan atau taip semula secara manual.",
    "sourceHash": "17223d30",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.1.lead": {
    "text": "KURANG RALAT",
    "sourceHash": "c89722c9",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.1.text": {
    "text": "Kurang kerja manual bermakna kurang ralat dan kos pembetulan, serta kos penyimpanan dan pencarian yang lebih rendah.",
    "sourceHash": "9f1a5b7a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.2.lead": {
    "text": "SEMAKAN GST",
    "sourceHash": "40d0c5f2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefit.2.text": {
    "text": "Penyelesaian InvoiceNow-Ready boleh membina semakan yang memberi amaran tentang caj GST yang salah daripada pembekal yang tidak berdaftar GST.",
    "sourceHash": "5e3dbd1c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefitStat.0.lead": {
    "text": "SIMPANAN",
    "sourceHash": "dc787b50",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefitStat.0.text": {
    "text": "Perniagaan boleh menjimatkan sehingga $20 bagi setiap invois melalui pengurangan pemprosesan manual.",
    "sourceHash": "4f67845a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefitStat.1.lead": {
    "text": "KADAR RALAT",
    "sourceHash": "c30963ee",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "benefitStat.1.text": {
    "text": "Kajian juga menunjukkan bahawa e-invois boleh mengurangkan kadar ralat invois sehingga 50%.",
    "sourceHash": "b0fff20f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.group": {
    "text": "IRAS",
    "sourceHash": "7be84b1e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.0.why": {
    "text": "Halaman rasmi: siapa yang mesti menyertai, tarikh dan apa yang perlu dibuat.",
    "sourceHash": "a19554a1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.1.why": {
    "text": "Panduan penuh untuk perniagaan berdaftar GST, termasuk empat jenis penghantaran.",
    "sourceHash": "c24f442e",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.2.why": {
    "text": "Jawapan terperinci kepada soalan lazim daripada perniagaan.",
    "sourceHash": "7edaf727",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.3.why": {
    "text": "Hamparan IRAS sendiri untuk menyemak tarikh pelaksanaan anda.",
    "sourceHash": "f017ed20",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.4.why": {
    "text": "Tanya IRAS bagaimana keperluan ini terpakai kepada perniagaan anda.",
    "sourceHash": "ea023a06",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.0.5.why": {
    "text": "Acara anjuran penyedia penyelesaian InvoiceNow-Ready, disenaraikan oleh IRAS.",
    "sourceHash": "9d236c3a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.group": {
    "text": "IMDA",
    "sourceHash": "ca38b594",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.0.why": {
    "text": "Tentang InvoiceNow, rangkaiannya dan faedahnya.",
    "sourceHash": "2396384d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.1.why": {
    "text": "Pakej percuma dan geran S$1k, S$5k dan Queen Bee, dengan borang tuntutan.",
    "sourceHash": "2612fe7a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.2.why": {
    "text": "Ringkasan satu halaman tentang kelayakan geran dan tarikh akhir.",
    "sourceHash": "b16a1d7d",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.3.why": {
    "text": "Siapa yang layak untuk geran dan cara menuntutnya.",
    "sourceHash": "a969c667",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.4.why": {
    "text": "Perisian bertauliah yang boleh anda gunakan untuk menghantar dan menerima invois dan melapor kepada IRAS.",
    "sourceHash": "cf1739ee",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.5.why": {
    "text": "Penyedia Access Point bertauliah, untuk perniagaan dengan ERP atau sistem dalaman sendiri.",
    "sourceHash": "80ed385f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.6.why": {
    "text": "Pakej penyelesaian percuma untuk perniagaan berdaftar GST, dengan tarikh setiap penyedia.",
    "sourceHash": "5035af93",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.7.why": {
    "text": "Minta penyedia penyelesaian percuma menelefon anda.",
    "sourceHash": "f57ad21b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.1.8.why": {
    "text": "Tanya IMDA tentang InvoiceNow dan geran.",
    "sourceHash": "2238ebe6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.2.group": {
    "text": "Ketahui lebih lanjut",
    "sourceHash": "d517a63a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.2.0.why": {
    "text": "Webinar IRAS-IMDA tentang persediaan untuk keperluan ini.",
    "sourceHash": "efd6e4ff",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "links.2.1.why": {
    "text": "Cari sama ada sesebuah perniagaan berada dalam rangkaian InvoiceNow.",
    "sourceHash": "dd4bd766",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.0.group": {
    "text": "Baca soalan lazim rasmi",
    "sourceHash": "274bf870",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.0.0.why": {
    "text": "Soalan tentang keperluan, versi 23 September 2026.",
    "sourceHash": "5db27b8b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.0.1.why": {
    "text": "Kelayakan dan tuntutan.",
    "sourceHash": "9f9bbe9a",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.1.group": {
    "text": "Soalan tentang kes anda sendiri",
    "sourceHash": "35540ec6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.1.0.why": {
    "text": "Tanya IRAS bagaimana keperluan ini terpakai kepada perniagaan anda.",
    "sourceHash": "a687ae87",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.1.1.why": {
    "text": "Tanya IMDA tentang InvoiceNow, rangkaian dan geran.",
    "sourceHash": "88920956",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.2.group": {
    "text": "Mencari penyedia?",
    "sourceHash": "d32a0c7c",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.2.0.why": {
    "text": "Minta penyedia penyelesaian percuma menelefon anda.",
    "sourceHash": "85f05924",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "help.2.1.why": {
    "text": "Acara anjuran penyedia yang boleh anda sertai.",
    "sourceHash": "29248e22",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.title": {
    "text": "Geran dan penyediaan kini mempunyai halaman sendiri",
    "sourceHash": "0988e2b2",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.0": {
    "text": "Halaman Geran baharu: Geran Peralihan GST InvoiceNow S$1,000 dan S$5,000, Geran Queen Bee S$25,000 dan Geran Penyelesaian Produktiviti, bersama jawapan soalan lazim yang berkaitan.",
    "sourceHash": "550aa9fe",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.1": {
    "text": "Halaman Perisian dan geran kini merangkumi pakej percuma, senarai penyedia dan alat bantu “Pilihan mana yang sesuai untuk saya?”, serta memaut ke halaman Geran.",
    "sourceHash": "c308dd08",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.2": {
    "text": "Panduan Penyediaan baharu: lima langkah senarai semak dalam satu halaman, setiap satu dengan sumber rasminya, carian ID Peppol, dan tempat anda log masuk untuk menggunakan InvoiceNow.",
    "sourceHash": "7b1f25ae",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.3": {
    "text": "Perisian dan geran: jadual yang menunjukkan sama ada perisian perakaunan popular (Xero, AutoCount, ABSS, SAP Business One, QuickBooks dan lain-lain) ada dalam senarai Penyedia Penyelesaian InvoiceNow-Ready IMDA bertarikh 12 Okt 2026.",
    "sourceHash": "b3359b0e",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-20.6.4": {
    "text": "Tajuk halaman yang lebih jelas.",
    "sourceHash": "bce15627",
    "translatedAt": "2026-10-20",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.title": {
    "text": "Pemilih bahasa, pautan senarai semak dan angka di halaman utama",
    "sourceHash": "ca71b95b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.0": {
    "text": "Halaman dalam bahasa Cina, Melayu dan Tamil kini tersedia sebagai terjemahan draf, ditanda dengan jelas sehingga disemak oleh penutur asli. Pilih bahasa di bahagian atas mana-mana halaman.",
    "sourceHash": "ea952d87",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.1": {
    "text": "Setiap langkah senarai semak kini dipautkan ke halaman atau alat yang berkaitan di laman ini.",
    "sourceHash": "0244a948",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.2": {
    "text": "Manfaat di halaman utama kini termasuk dua angka utama: penjimatan sehingga $20 bagi setiap invois, dan kadar ralat invois dikurangkan sehingga 50%.",
    "sourceHash": "0867745b",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.5.3": {
    "text": "Halaman “Perisian percuma” kini dinamakan “Perisian dan geran”, dengan alat baharu “Pilihan mana yang sesuai untuk saya?”. Butang “Apa yang patut saya buat?” di bahagian atas setiap halaman membuka senarai semak.",
    "sourceHash": "b845a176",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.4.title": {
    "text": "Versi bahasa Cina, Melayu dan Tamil disediakan",
    "sourceHash": "2b37db34",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.4.0": {
    "text": "Laman ini kini boleh dipaparkan dalam bahasa Cina Ringkas, Melayu dan Tamil. Terjemahan adalah tidak rasmi dan versi bahasa Inggeris yang terpakai.",
    "sourceHash": "b1ce89f1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.4.1": {
    "text": "Sesebuah halaman hanya diterbitkan dalam sesuatu bahasa selepas penutur asli menyemak setiap ayat di dalamnya.",
    "sourceHash": "78d0cacb",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.3.title": {
    "text": "Dipecahkan kepada halaman mengikut topik",
    "sourceHash": "1bad2e23",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.3.0": {
    "text": "Halaman utama yang panjang kini menjadi gambaran ringkas dengan senarai semak. Tarikh dan kalkulator, perisian percuma dan geran, cara ia berfungsi, POS dan runcit, dan soalan lazim masing-masing ada halaman sendiri.",
    "sourceHash": "e829e950",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.2.title": {
    "text": "Jawapan baharu daripada soalan lazim IRAS, dan kalkulator tarikh yang lebih tepat",
    "sourceHash": "0b41e916",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.2.0": {
    "text": "Jawapan soalan lazim baharu: POS dan jualan agregat, tarikh akhir penghantaran, ID pengakuan, penghantaran semula dan nota kredit, pendaftaran kumpulan GST, pelanggan yang tiada dalam InvoiceNow, dan penalti.",
    "sourceHash": "48230640",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.2.1": {
    "text": "Kalkulator tarikh kini mengikut soalan lazim IRAS Q1.5 hingga Q1.12 dan Q7.2: tempoh perakaunan bukan tahun kalendar, penyata sifar, penyata sebahagian tahun, pendaftar sukarela dan wajib baharu, syarikat yang dipindahkan pendaftarannya, perniagaan terkecuali dan kumpulan GST.",
    "sourceHash": "cad24b17",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.title": {
    "text": "Kebebasan dan sumber yang lebih jelas",
    "sourceHash": "1b786b97",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.0": {
    "text": "Setiap halaman kini dibuka dengan sepanduk yang menyatakan laman ini bebas dan tidak bergabung dengan IRAS atau IMDA.",
    "sourceHash": "bff02dff",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.1": {
    "text": "Halaman Tentang baharu: mengapa laman ini wujud, bagaimana kandungan disemak, dan privasi.",
    "sourceHash": "37457db6",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.2": {
    "text": "Log perubahan awam baharu (halaman ini).",
    "sourceHash": "e84748e0",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.1.3": {
    "text": "Halaman utama menunjukkan tarikh kandungan kali terakhir disemak berbanding sumber rasmi.",
    "sourceHash": "34039bc5",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.title": {
    "text": "Kandungan disemak berbanding sumber IRAS dan IMDA terkini",
    "sourceHash": "7658597f",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.0": {
    "text": "Pakej percuma: kini mengikut senarai IMDA bertarikh 17 September 2026 (percuma tanpa syarat, tersedia sehingga 31 Mac 2031, tarikh berbeza mengikut penyedia). Ayat tanpa sumber bahawa sesetengah penyedia mengenakan bayaran mengikut penggunaan atau langganan telah dibuang.",
    "sourceHash": "5bb75433",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.1": {
    "text": "Pengecualian: “permohonan pengecualian ditolak” diganti dengan apa yang sebenarnya dinyatakan dalam soalan lazim IRAS Q2.6 dan Q1.14.",
    "sourceHash": "c9587149",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.2": {
    "text": "Sumber kini dinyatakan bagi setiap ayat, dengan nombor soalan lazim dan perenggan e-Tax Guide.",
    "sourceHash": "9d9ae8f1",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.3": {
    "text": "Tiga statistik di halaman utama (penjimatan setiap invois, kelajuan pembayaran, kadar ralat) yang tidak dapat kami jejak kepada sumber rasmi telah dibuang.",
    "sourceHash": "f2596592",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  },
  "change.2026-10-14.0.4": {
    "text": "Panduan 3 hingga 12 bulan untuk menyambungkan sistem dalaman kini memetik perenggan 13.6 e-Tax Guide.",
    "sourceHash": "aa9c55a2",
    "translatedAt": "2026-10-14",
    "reviewedBy": null,
    "reviewedAt": null
  }
}
